import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useAppStateStore } from "@/services/pinia.service";
import { computed } from "vue";
import router from "@/router";
import { GameState } from "@/models/enums/GameState";


export default /*#__PURE__*/_defineComponent({
  __name: 'RefreshComponent',
  setup(__props) {

const appState = useAppStateStore();
const disabeld = computed(() => {
  const path = router.currentRoute.value.fullPath;
  if (path) {
    return !["/join-game-lobby", "/community-cards"].includes(path);
  } else {
    return true;
  }
});

const backGroundColor = computed(() => {
  const night = appState.getAppState.game?.state === GameState.NIGHT;
  if (night) {
    return "NIGHT";
  } else {
    return "app-background";
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_pull_to_refresh = _resolveComponent("q-pull-to-refresh")!

  return (_openBlock(), _createBlock(_component_q_pull_to_refresh, {
    onRefresh: _unref(appState).getRefreshFunction,
    color: "red",
    class: _normalizeClass(backGroundColor.value),
    "bg-color": "black",
    icon: "autorenew",
    disable: disabeld.value
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["onRefresh", "class", "disable"]))
}
}

})